import { FC, memo } from 'react';
import { useLocation } from 'react-router-dom';
import { useProductCoursesQuery } from 'src/hooks/useProductCourses.query';

import ProductCourseReportPresenter from './ProductCourseReportPresenter';
import { useIssueDateTime } from './reports/useIssueDateTime';

/**
 * 商品別コースリスト のページ。
 * `/product-course-list?start_on=YYYY-MM-DD&end_on=YYYY-MM-DD&shipper_names[]=...` で表示される。
 */
const ProductCourseReport: FC = memo(() => {
  const query = new URLSearchParams(useLocation().search);
  const startOn = query.get('start_on') ?? '';
  const endOn = query.get('end_on') ?? '';
  const shipperNames = query.getAll('shipper_names[]');
  const hasMissingParams = !startOn || !endOn || shipperNames.length === 0;

  const { data, isLoading, isError } = useProductCoursesQuery({ startOn, endOn, shipperNames });
  const { issueDate, issueTime } = useIssueDateTime();

  return (
    <ProductCourseReportPresenter
      data={data}
      isLoading={isLoading}
      isError={isError}
      hasMissingParams={hasMissingParams}
      issueDate={issueDate}
      issueTime={issueTime}
    />
  );
});

export default ProductCourseReport;
